import { analytics } from 'modules/analytics';
import { useEffect, memo } from 'react';
import { getCookie } from 'utils';

const AuthTransitions = () => {
  const userId = getCookie('user_id') || getCookie('emp_id');

  useEffect(() => {
    if (userId) {
      analytics.login(userId, 'ADMIN');
    } else {
      analytics.logout();
    }
  }, [userId]);

  return null;
};

export default memo(AuthTransitions);
